import { ApplicationStage, DocumentCategory, OfferBundleStatus, QueryResult } from "common";
import { BrokerStatus } from "@partner/shared/SharedConstants";
import { QueryParamsBase } from "../../shared/filters/filter.model";
import { SubmissionDetailsAppBarStatusType } from "../../features/submission-details/shared/components/submission-details-app-bar-title/submission-details-app-bar-title.model";

export interface SubmissionData {
  id: number
  accountName: string;
  assignedAgent: string;
  firstAgent: string;
  brokerStatus: BrokerStatus;
  stage: ApplicationStage;
  previousStage: ApplicationStage;
  createdOn: Date;
  updatedOn: Date;
  information: string;
  loanId: number;
  loanNumber: string;
}

export interface SubmissionsQueryResult extends QueryResult<SubmissionData> { }

export interface SubmissionQueryParams extends QueryParamsBase {
  accountName?: string;
  brokerStatus?: BrokerStatus[];
  firstAgent?: string;
  assignedAgent?: string;
  createdOn?: string;
  createdOnFrom?: string;
  createdOnTo?: string;
  updatedOn?: string;
  updatedOnFrom?: string;
  updatedOnTo?: string;
}

export interface SubmissionsHintsQueryParams {
  fieldName: SubmissionsHintsFieldName;
  value: string;
  limit?: number;
}

export enum SubmissionsHintsFieldName {
  AccountName = "accountName",
  FirstAgent = "firstAgent",
  AssignedAgent = "assignedAgent",
}

export interface SubmissionsHintsResponse {
  values: string[];
  validationMessage?: string;
}

export interface DeleteRequirementDocumentData {
  requirementId: number;
  documentId: number;
}

export interface DownloadRequirementDocumentData {
  requirementId: number;
  documentId: number;
  filename: string;
}

export interface SaveRequirementDocumentData {
  requirementId: number;
  category: DocumentCategory;
  name: string;
  type: string;
  data: Blob;
}

export interface UpdateOfferBundleStatusData {
  applicationId: number;
  offerBundleId: number;
  status: OfferBundleStatus;
}

export interface UpdateSubmissionDetailsAppBarTitleData {
  title?: string;
  statusType?: SubmissionDetailsAppBarStatusType;
}
